// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import todo from "@src/views/apps/todo/store";
import chat from "@src/views/kullanici_islemleri/mesajlasma/store";
import users from "@src/views/apps/user/store";
import email from "@src/views/apps/email/store";
import kanban from "@src/views/apps/kanban/store";
import invoice from "@src/views/apps/invoice/store";
import calendar from "@src/views/apps/calendar/store";
import ecommerce from "@src/views/apps/ecommerce/store";
import dataTables from "@src/views/tables/data-tables/store";
import permissions from "@src/views/apps/roles-permissions/store";
import KullaniciListesi from "@src/views/kullanici_islemleri/kullanici_yonetimi/store";
import KullaniciDetay from "@src/views/kullanici_islemleri/kullanici_yonetimi/store";
import Category from "@src/views/magaza_yonetimi/kategoriler/store";
import UserPermissions from "@src/router/store";

const rootReducer = {
    auth,
    todo,
    email,
    users,
    kanban,
    navbar,
    layout,
    chat,
    invoice,
    calendar,
    ecommerce,
    dataTables,
    permissions,
    KullaniciListesi,
    KullaniciDetay,
    Category,
    UserPermissions
};

export default rootReducer;
